import { RelatedCourseController } from './related-course.controller';
import { RelatedCourseProps } from './related-course.model';

export const RelatedCourse = (props: RelatedCourseProps) => {
  return <RelatedCourseController {...props} />;
};
